/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum CohortstatusVanaf {
    NOG_BEZIG = "Nog bezig",
    TUSSENTIJDS_UITGESTROOMD = "Tussentijds uitgestroomd",
    VOLLEDIG_COHORT_GEVOLGD = "Volledig cohort gevolgd"
}
